// ************************************</editor-fold>
// VARIABLES
// ************************************<editor-fold>
let popupcount, popupTotal, visitedNewsSection;
popupcount = 0;
popupTotal = 2;
visitedNewsSection = false;
const totalCarousel = $('#news-carousel .carousel-item').length - 1;
const overlayData = {
    richestMan: `This story contains opinions critical of the ruling elite, so it has been taken down.<br> Please try another article.`,
    bedroomTrick: `This story contains something considered naughty by our filters, and as such we need to verify you’re over 18.<br> Please visit your local age verification centre.`,
    automatedIndustry: `The AI writers are currently on strike, this story will be available shortly.`,
    fuelTaxes: `Due to unexpected demand from your area, your ISP has temporarily throttled your speeds and we are unable to load this page.<br> Please try again later.`,
    collusion: `This story has unexpectedly been deleted by an unknown user.<br> Please try another article.`,
    eu: `The comments section of this story has been taken over by Russian bots, and as a result we’ve shut it down.<br> Please try another article.`,
    memoryImplants: `We’ve forgotten what we’re supposed to be writing about, please try again later.`,
    vrAccidents: `This story contains memes, which are unavailable in your country due to copyright law.<br> Please try another article.`
};

// ************************************</editor-fold>
// EVENTS
// ************************************<editor-fold>
const newsEvents = new EventDelegator([{
    selector: '#js-app',
    eventType: 'click',
    events:
        {
            aicontrol: (e, d) =>
            {
                aiStoriesControl((d.aicontrol === 'remove'), (d.aicontrol === 'adjust'))
            },
            aioverlay: (e, d) =>
            {
                aiArticleOverlay(d.aioverlay, (d.aioverlay === 'hide'));
            },
            newspopup: (e, d) =>
            {
                popupContinue();
            },
            newscarousel: (e, d) =>
            {
                const moveTo = ((d.newscarousel === 'next') || (d.newscarousel === 'prev')) ? d.newscarousel : parseInt(d.newscarousel, 10);
                $('#news-carousel').carousel(moveTo);
            }
        }
}]);

$('#news-carousel').carousel({interval: false});
$('#news-carousel').on('slid.bs.carousel', function (e)
{
    const forwardTarget = $('#news-carousel .news-carousel__btn--forward');
    const backTarget = $('#news-carousel .news-carousel__btn--back');

    (e.to === totalCarousel) ?
        forwardTarget.addClass('news-carousel__btn--last')
        :
        forwardTarget.removeClass('news-carousel__btn--last');

    (e.to === 0) ?
        backTarget.addClass('btn--disabled')
        :
        backTarget.removeClass('btn--disabled');
});

// ************************************</editor-fold>
// FUNCTIONS
// ************************************<editor-fold>
function popupContinue()
{
    visitedNewsSection = true;
    const card = $('#intro-popups__card');
    const container = $('#news__intro-popups');

    container.fadeIn(500);

    const classes = (popupcount === 1) ? 'intro-popups__card--second-card bounceIn' : 'bounceIn';
    card.addClass(classes);
    setTimeout(function ()
    {
        card.removeClass('bounceIn');
    }, 510);

    popupcount += 1;
    if (popupcount > popupTotal)
    {
        container.fadeOut(500);
        card.addClass('bounceOut');
        setTimeout(function ()
        {
            $('#news').removeClass('news--intro-popups');
            container.remove();
        }, 500);
    }
}

function aiArticleOverlay(overlayDataTarget, hide)
{
    const children = $('#news > div');
    const target = $('#news__overlay');
    hide ? children.fadeIn() : children.hide();
    hide ? target.hide() : target.fadeIn();

    if (!hide)
    {
        $('#news__overlay--text').html(overlayData[overlayDataTarget]);
    }
}

function aiStoriesControl(remove, adjust)
{
    if (adjust)
    {
        $('#ai-control__collapsible').slideDown();
        $('#ai-control__title').html('Hate our AI-written stories? 70% of our news is written by robots.');
        $('#ai-control__adjust-btn').fadeOut();
    }
    else
    {
        const message = remove ? 'AI-written stories have been removed!' : 'AI-written stories have been included!';
        $('#ai-control__title').html(message);

        $('#ai-control__collapsible').slideUp();
        $('#ai-control__adjust-btn').fadeIn();

        const ignoreBtn = $('.ai-control__btn--ignore');
        remove ?
            ignoreBtn.attr('data-preventkaching', 'false')
            :
            ignoreBtn.attr('data-preventkaching', 'true');


        const news = $('#news');
        remove ?
            news.addClass('news__ai-articles--disabled')
            :
            news.removeClass('news__ai-articles--disabled');
    }
}
